// Note: This file will excluded altogether once it has been refactored in to it's own module
// and published to the registry. This is because cookie cutter doesn't support excluding files.

// Angular
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { ModuleWithProviders } from '@angular/compiler/src/core';

import { AuthGuard, MustBeLoggedInGuardService, MustBeAdminGuardService, HasAccessGuard } from './guards';
import { LoginService } from './login.service';
//import { AuthModuleConfig } from './models/auth-module-config.model';

// Third Party
import { OAuthService, OAuthModule  } from 'angular-oauth2-oidc';


@NgModule({
  providers: [
    AuthGuard,
    MustBeLoggedInGuardService,
    MustBeAdminGuardService,
    HasAccessGuard
  ],
  imports: [
    OAuthModule.forRoot(
    //  https://github.com/manfredsteyer/angular-oauth2-oidc
    ////Since 3.1 you can also automate this task by switching sendAccessToken on and by setting allowedUrls to an array with prefixes for the respective URLs. Use lower case for the prefixes.
    ////Not tested
    //  {
    //  resourceServer: {
    //    allowedUrls: ['http://localhost:61536/api'],
    //    sendAccessToken: true
    //  }
    //}
    )
  ],
  declarations: []
})
//@Injectable()
export class AuthModule {
  public static forRoot(/*config: AuthModuleConfig*/): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        //{ provide: 'raw-auth-module-config', useValue: config },
        //{ provide: 'auth-module-config', useFactory: getAuthModuleConfig, deps: ['raw-auth-module-config'] },
        LoginService
      ]
    };
  }

  /* make sure AuthModule is imported only by one NgModule the AppModule */
  constructor(
    @Optional() @SkipSelf() parentModule: AuthModule
  ) {
    if (parentModule) {
      throw new Error('AuthModule is already loaded. Import only in AppModule');
    }
  }



}

//export function getAuthModuleConfig(config) { const cfg = new AuthModuleConfig(); Object.assign(cfg, config); return cfg; }
